export enum IndicatorType {
  Eight = 8,
  Eleven = 11,
  Twelve = 12,
  Thirteen = 13,  
  Fourteen = 14,
  FacilitatedSelfAssessment = 32,
  PersonnelStatus = 33,
  StandardRecordReview = 34,
  CorrectiveActionPLans = 35,
}

export enum Prong1StatusType {
  NA = 0,
  Incomplete = 1,
  Submitted = 2,
  Review_In_Progress = 3,
  Action_Required = 4,
  Accepted = 5,
}

export enum Prong2StatusType {
  NA = 0,
  Pending = 11,
  File_Requested = 12,
  File_Submitted = 13,
  Compliant_Cleared = 14,
  Noncompliant_Pending = 16,
  Continued_Noncompliance_Final = 17,
}

export enum CollectionStatusType {
  NA = 0,
  NotStarted = 11,
  InProgress = 12,
  Completed = 13,
}

export enum StandardRecordReviewAgeGroupType {
  NA = 0,
  EarlyChildhood = 1,
  StandardRecord = 2,
  TransitionRecord = 3,
}
